import * as yup from 'yup';
export const carePlanPresetsSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    practiceId: yup.number().required().integer(),
    category: yup.string().required(),
    field: yup.string().required(),
    value: yup.string().required(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
